import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function removerChavePixSicoob(empresaId, chaveId) {
  const url = `${URL}/empresas/${empresaId}/sicoob/chave-pix/${chaveId}`;
  return () => axios.delete(url, SLOW_REQUEST_CONFIG);
}
